export default __webpack_public_path__ + "static/media/poll-h.5e5d046a.svg";